var _classCallCheck = require("D:\\Projects\\SoLiDRDP\\solid-rdm\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Projects\\SoLiDRDP\\solid-rdm\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("D:\\Projects\\SoLiDRDP\\solid-rdm\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\Projects\\SoLiDRDP\\solid-rdm\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("D:\\Projects\\SoLiDRDP\\solid-rdm\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _wrapNativeSuper = require("D:\\Projects\\SoLiDRDP\\solid-rdm\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/wrapNativeSuper");

/**
 * KeyUsage
 */
var KeyUsage =
/*#__PURE__*/
function (_Array) {
  "use strict";

  _inherits(KeyUsage, _Array);

  /**
   * constructor
   */
  function KeyUsage(collection) {
    var _this;

    _classCallCheck(this, KeyUsage);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(KeyUsage).call(this));
    collection.forEach(function (item) {
      return _this.push(item);
    });
    return _this;
  }
  /**
   * normalize
   */


  _createClass(KeyUsage, [{
    key: "normalize",
    value: function normalize(usages) {
      var result = [];

      for (var i = 0; i < this.length; i++) {
        var usage = this[i];

        if (usages.includes(usage)) {
          result.push(usage);
        }
      }

      return result;
    }
  }]);

  return KeyUsage;
}(_wrapNativeSuper(Array));
/**
 * Export
 */


module.exports = new KeyUsage(['encrypt', 'decrypt', 'sign', 'verify', 'deriveBits', 'wrapKey', 'unwrapKey']);